import api from './api';

const invoiceService = {
  getAll: async (filters?: any) => {
    return api.get('/invoices', { params: filters });
  },

  getById: async (id: string) => {
    return api.get(`/invoices/${id}`);
  },

  create: async (invoiceData: any) => {
    return api.post('/invoices', invoiceData);
  },

  update: async (id: string, invoiceData: any) => {
    return api.put(`/invoices/${id}`, invoiceData);
  },

  addNote: async (id: string, text: string) => {
    return api.post(`/invoices/${id}/notes`, { text });
  },

  uploadDocument: async (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/invoices/${id}/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  exportToCSV: async () => {
    return api.get('/invoices/export/csv', {
      responseType: 'blob',
    });
  },

  // PO-related methods
  exportPOToPDF: async (id: string) => {
    return api.get(`/purchase-orders/${id}/pdf`, {
      responseType: 'blob',
    });
  },
};

export default invoiceService;
